import { getRCSErrors } from "../api/RCSDashboardApi";
import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../../../Context/AuthContext";
export const useRCSError = ({ visible }) => {
  const auth = useAuth();
  const user = auth.getSessionData();
  return useQuery({
    queryKey: ["RCSError"],
    queryFn: async () => {
      return await getRCSErrors({ token: user.token });
    },
    initialData: [],
    refetchOnWindowFocus: false,
    enabled: visible,
  });
};
